import AxiosAPI from "@qualitas/libs";
import { AxiosResponse } from "axios";
import { UserPermissionsAdminUser } from "../Models";

export const UserPermissionsAdminAPI = (baseURLExternal: string | undefined, clientId: string) => {
	const api = AxiosAPI({
		baseURL: baseURLExternal,
		clientId,
		isApp: true,
		hasUnderMaintenance: false
	});

	const getUserTypes = () => (
		api.get("/auth-api/UserType/GetUserTypeList")
			.then((response: AxiosResponse) => response?.data?.data ?? [])
			.catch((error: any) => Promise.reject(error))
	);

	const getInstitutions = () => (
		api.get("/masters-api/Institution/GetPlacementAgentInstitutions")
			.then((response: AxiosResponse) => response?.data ?? [])
			.catch((error: any) => Promise.reject(error))
	);

	const getContacts = () => (
		api.get("/masters-api/Contact/GetContacts")
			.then((response: AxiosResponse) => response?.data ?? [])
			.catch((error: any) => Promise.reject(error))
	);

	const getContactInformation = (idContact: number, idSystemMaster: number) => (
		api.get("/auth-api/User/GetUserInfoAndPermissions", {
			params: {
				IdContact: idContact,
				IdSystemMaster: idSystemMaster
			}
		})
			.then((response: AxiosResponse) => response?.data?.data ?? null)
			.catch((error: any) => Promise.reject(error))
	);

	const saveContactInformation = (data: UserPermissionsAdminUser) => (
		api.put("/auth-api/User/UpdateUserData", data)
			.then((response: AxiosResponse) => response?.data)
			.catch((error: any) => Promise.reject(error))
	);

	const createUser = (loginName: string, idContact: number) => (
		api.post("/auth-api/User/CreateUser", { loginName, idContact })
			.then((response: AxiosResponse) => response?.data?.data)
			.catch((error: any) => Promise.reject(error))
	);

	const requestPasswordReset = (email: string) => (
		api.post("/auth-api/Auth/RequestPasswordReset", { email })
			.then((response: AxiosResponse) => response?.data?.data)
			.catch((error: any) => Promise.reject(error))
	);

	return {
		getUserTypes,
		getInstitutions,
		getContacts,
		getContactInformation,
		saveContactInformation,
		createUser,
		requestPasswordReset
	};
};
